import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Collection } from '../../../collections/Collection';

export const SearchPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    searchParams.get('q');

    return <Collection search={searchParams.get('q')} />;
};
